export default () => {
  let tmp = ''
  if( window.location.host.indexOf( 'idr' ) > -1 ) {
    tmp = 'IDR'
  } else {
    tmp = 'MYR'
  }
  return tmp
}